// extracted by mini-css-extract-plugin
export var productImage = "_z7-0";